import { VideoHTMLAttributes } from 'react'

export interface VideoPlayerFeatures {
  playPause?: boolean
  currentTime?: boolean
  duration?: boolean
  seek?: boolean
  volume?: boolean
  playbackRate?: boolean
  fullscreen?: boolean
}

export interface VideoPlayerLabels {
  video: string
  play: string
  pause: string
  seek: string
  volume: string
  mute: string
  unmute: string
  playbackSpeed: string
  enterFullscreen: string
  exitFullscreen: string
}

export interface VideoPlayerProps
  extends Omit<VideoHTMLAttributes<HTMLVideoElement>, 'controls'> {
  features?: VideoPlayerFeatures
  labels?: Partial<VideoPlayerLabels>
  videoClassName?: string
  autoHideControls?: boolean
  controlsHideDelay?: number
}
